import React from 'react';
import { getSchoolConfig } from '../utils/domainConfig';
import '../styles/ContactModal.css';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  const school = getSchoolConfig();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="contact-modal" onClick={e => e.stopPropagation()}>
        <button className="close-modal" onClick={onClose}>&times;</button>
        <h2>Contact Us</h2>
        <div className="contact-info">
          <div className="contact-item">
            <i className="fas fa-envelope"></i>
            <span>Email: {school.email}</span>
          </div>
          {school.phones.map(phone => (
            <div className="contact-item" key={phone}>
              <i className="fas fa-phone"></i>
              <span>+91 {phone}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
